import { render, staticRenderFns } from "./updateRecord.vue?vue&type=template&id=23e18b47&scoped=true&"
import script from "./updateRecord.vue?vue&type=script&lang=js&"
export * from "./updateRecord.vue?vue&type=script&lang=js&"
import style0 from "./updateRecord.vue?vue&type=style&index=0&id=23e18b47&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e18b47",
  null
  
)

export default component.exports